import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { TrivecSetupRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { InputText } from '@/components/shared/InputText';
import {
    SecondaryButtonStyle,
    PrimaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';

interface TrivecConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const TrivecConnect = (props: TrivecConnectProps) => {
    const { t } = useTranslation();
    const [trivecData, setTrivecData] = useState<TrivecSetupRequest>({
        appId: ''
    });
    const { setAlert } = useNotificationsSnackbar();

    const { setupTrivec } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        setupTrivec.mutate({
            appId: trivecData?.appId
        });
    };

    useEffect(() => {
        if (setupTrivec.isSuccess) {
            props.onSaveSuccess?.();
        }
    }, [setupTrivec.isSuccess]);

    useEffect(() => {
        if (setupTrivec.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [setupTrivec.isError]);

    useEffect(() => {
        dispatch(setLoader(setupTrivec.isPending));
    }, [setupTrivec.isPending]);

    const isFormValid = () => {
        return trivecData.appId && trivecData.appId.trim() !== '';
    };

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={trivecData.appId}
                    label={t('trivec_app_id')}
                    placeholder={t('enter_trivec_app_id')}
                    onChange={(e) => {
                        setTrivecData({
                            ...trivecData,
                            appId: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle onClick={props.onClose}>
                    {t('back')}
                </SecondaryButtonStyle>
                <PrimaryButtonStyle disabled={!isFormValid()} onClick={onClick}>
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
